import { render } from "./Dowload&Use.md?vue&type=template&id=34d45d6c"
const script = {}
script.render = render

export default script